lmApp
  .controller('StripeController', ['$scope', '$rootScope', '$routeParams', '$timeout', '$interval', '$templateCache', '$compile', 'SupervisorService', 'BillingService', 'ToastService', 'ModalWindowService',
    function ($scope, $rootScope, $routeParams, $timeout, $interval, $templateCache, $compile, SupervisorService, BillingService, ToastService, ModalWindowService) {
      $scope.loading = false;
      $scope.stripeStatus = true;

      $scope.stripeConnect = function () {
        if ($scope.loading) return;

        var host = window.location.protocol + '//' + window.location.host;

        if ($scope.isLive) {
          window.open('https://connect.stripe.com/oauth/authorize?response_type=code' +
            '&client_id=' + $scope.clientId +
            '&redirect_uri=' + encodeURIComponent(host.replace('http://', 'https://') + '/billing/stripeconnect') +
            '&scope=read_write',
            'newwindow', 'width=' + window.innerWidth / 1.3 + ', height=' + window.innerHeight / 1.3 + ', left=350, top=150');
        } else {
          window.open('https://connect.stripe.com/oauth/authorize?response_type=code' +
            '&client_id=' + $scope.clientId +
            '&redirect_uri=' + encodeURIComponent(host + '/billing/stripeconnect?devmode=1') +
            '&scope=read_write',
            'newwindow', 'width=' + window.innerWidth / 1.3 + ', height=' + window.innerHeight / 1.3 + ', left=350, top=150');
        }

        return false;
      };

      $scope.stripeDisconnect = function () {
        if ($scope.loading) return;

        var tpl = $templateCache.get('stripe-disconnect-manual.html');
        tpl = $compile(tpl)($scope);

        ModalWindowService.Open({
          content: tpl,
          size: {
            s: 5
          },
          actions: [{
            title: 'OK',
            color: 'lm',
            fn: function () {
            }
          }]
        });
      };

      if ($routeParams.devmode) {
         $scope.clientId = 'ca_6qA0owYgGr2TFkN94r6YZ2xEbRqf9Duo'; // SotalCloud (Dev)
        //$scope.clientId = 'ca_6qA0owYgGr2TFkN94r6YZ2xEbRqf9Duo'; // SotalCloud (Prod)
        $scope.isLive = false;
      } else {
         $scope.clientId = $rootScope.stripe.clientId;
        //$scope.clientId = 'ca_6qA0rusByFmq19FVQP3IyI6cYSuNDUcB';
        $scope.isLive = $rootScope.stripe.isLive;
      }

      if ($routeParams.code) {
        $scope.stripeCode = $routeParams.code;

        angular.element('body').addClass('modal-open');

        BillingService.EbsStripeInstall($scope.stripeCode, $scope.isLive)
          .then(function (response) {
            $rootScope.hideLinearProgress('#connectLoader');
            ToastService.Big({
              title: 'Stripe connect',
              text: 'Your stripe account successfully connected',
              color: 'green',
              icon: 'code-string'
            }, 6000);

            $timeout(function () {
              window.close();
            }, 3000);
          })
          .catch(function (reason) {
            $scope.stripeError = reason.message;
            $rootScope.hideLinearProgress('#connectLoader');
            ToastService.Big({
              title: 'Stripe connect',
              text: 'Failed stripe connect. ' + reason.message,
              color: 'deep-orange',
              icon: 'code-string'
            })
          }, 6000);
      } else if ($routeParams.error) {
        $scope.stripeError = $routeParams.error;
      } else {
        SupervisorService.Self()
          .then(function (response) {
            $scope.stripeStatus = !!_.find(response.self.services, {name: 'ebs.stripe'});

            $scope.selfInt = $interval(function () {
              if ($scope.selfIntInProgress) return;

              $scope.selfIntInProgress = true;

              SupervisorService.Self()
                .then(function (response) {
                  $scope.stripeStatus = !!_.find(response.self.services, {name: 'ebs.stripe'});
                  $scope.selfIntInProgress = false;
                })
                .catch(function () {
                  $scope.selfIntInProgress = false;
                })
            }, 60000);
          })
          .catch(function () {
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          })
      }

      $scope.$on('$destroy', function () {
        $interval.cancel($scope.selfInt);
      });
    }]);